import getLang from "../helpers/_getLang";

export default function countDown() {
  const $countDown = $('.js-countdown');
  const lang = getLang();

  if ($countDown.length) {
    const finishEvent = {
      year: +$countDown.data('year'),
      month: +$countDown.data('month'),
      day: +$countDown.data('day'),
    };
    const { year, month, day } = finishEvent;

    // eslint-disable-next-line no-undef
    simplyCountdown('.js-countdown', {
      year,
      month,
      day,
      onEnd() {
        $countDown.hide();
        $('.js-timer-not-ended-msg').hide();
        $('.js-timer-ended-msg').show();
      },
      words: {
        days: lang === 'ru' ? 'дней' : 'днів',
        hours: lang === 'ru' ? 'часов' : 'годин',
        minutes: lang === 'ru' ? 'мин' : 'хв',
        seconds: 'сек',
      },
      plural: false
    });
  }
}
